export default {
	loadingData: 'กำลังดาวน์โหลดข้อมูล ... Please wait',
};
